<div [formGroup]="pickListForm">
  <div class="flexholder">
    <div class="listOptions">
      <div class = "labelRow">
        <!--First comboBox-->
        <kendo-floatinglabel *ngIf="firstSelectorActive" text={{firstLabelName}} >
         <kendo-combobox
           formControlName="firstSelector"
           [data]="firstSelectorList"
           (valueChange)="firstSelectorValueChange($event)"
           style ="    width:175px ; height: 29px; border-radius:12px"
         >
         </kendo-combobox>
        </kendo-floatinglabel>

        <kendo-floatinglabel *ngIf="secondSelectorActive" text={{secondLabelName}}
        >
          <kendo-combobox *ngIf="secondSelectorActive"
            formControlName="secondSelector"
            [data]="secondSelectorList"
            (valueChange)="secondSelectorValueChange($event)"
            style ="    width:175px ; height: 29px; border-radius:12px"
          >
          </kendo-combobox>
        </kendo-floatinglabel>
      </div>
        <div class="outsideContainer">
          <kendo-grid class="rowGrid"
            [data]="currentAvailable"
            [kendoGridSelectBy]="'name'"
            [selectedKeys]="availableSelected"
            (selectedKeysChange)="keyChangeAdd($event)"
            [selectable]="{checkboxOnly: false, mode: 'multiple'}"
          >
  
            <kendo-grid-column [field]="'name'" title="Available"
            filterable="true"  [width]="100">
            </kendo-grid-column>
          </kendo-grid>

          <div class="grid-commands">
            <app-mcl-button class="buttonFixedWidth" text="Add >" primary="true" (click)="addClicked($event)"></app-mcl-button>
            <app-mcl-button class="buttonFixedWidth" text="Add All >>" primary="true" (click)="addAllClicked($event)"></app-mcl-button>
            <app-mcl-button class="buttonFixedWidth" text="< Remove" primary="true" (click)="removeClicked($event)"></app-mcl-button>
            <app-mcl-button class="buttonFixedWidth" text="<< Remove All" primary="true" (click)="removeAllClicked($event)"></app-mcl-button>
          </div>

          <kendo-grid class="rowGrid" style="height: 400px"
            [data]="currentAssigned"
            [filterable]="true"
            [sortable]="true"
            [resizable]="true"
            [reorderable]="true"
            [kendoGridSelectBy]="'name'"
            [selectedKeys]="assignedSelected"
            (selectedKeysChange)="keyChangeRemove($event)"
            [selectable]="{checkboxOnly: false, mode: 'multiple'}"
          >
            <kendo-grid-column [field]="'name'" title="Assigned"></kendo-grid-column>
          </kendo-grid>
        </div>
      <app-mcl-button [disabled]="(!pickListForm.valid || !this.gridChanged) && !parentGridChange" class="buttonFixedWidth" text="Save" primary="true" (click)="onSubmit()"></app-mcl-button>
    </div>
  </div>
</div>
<div kendoDialogContainer></div>
